import axios from 'axios'
import { Message } from 'element-ui'
import store from '../store'
import { getToken } from '@/utils/auth'
import { reLogin } from '@/utils'
import getLang from '@/lib/getBrowserLang'

// 创建axios实例
const service = axios.create({
  baseURL: '', // api的base_url
  withCredentials: true,
  timeout: 15000, // 请求超时时间
  headers: { 'Content-Type': 'application/json;charset=utf-8' }
})

// request拦截器
service.interceptors.request.use(config => {
  let langList = navigator.languages && navigator.languages.length > 0 ? navigator.languages : []
  langList = Array.from(new Set([getLang(), ...langList]))
  config.headers['Accept-Language'] = langList.join(',')
  if (config.domain !== 'NO_DOMAIN') {
    const domainConfig = store.getters.domain.DOMAIN || {}
    const domain = (config.baseURL || 'USERCENTER')
    config.baseURL = domainConfig[domain]    
  }
  if (store.getters.token) {
    config.headers['X-Token'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
  }

  config.params = Object.assign(config.params || {}, {
    reqtime: new Date().getTime()
  })
  return config
}, error => {
  // Do something with request error
  // console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    Promise.resolve(response.data)
    return response.data
  },
  error => {
    if (error.response.status === 401) {
      reLogin()
    }
    Message({
      showClose: true,
      message: error.response.data.message || error.response.data.error || 'error',
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

const request = arg => {
  return new Promise((resolve, reject) => {
    service(arg).then(response => {
      // if (response.status === 200) {
      //   resolve(response)
      // } else {
      //   Message({
      //     message: response.message || response.error || 'error',
      //     type: 'error',
      //     duration: 5 * 1000
      //   })
      //   reject(response)
      // }
      resolve(response)
    }).catch(error => {
      reject(error)
    })
  })
}

export default request



// WEBPACK FOOTER //
// ./src/utils/request.js